export const ENVIRONMENT_STATE_KEY = {
  CURRENT_PERSONA: 'currentPersona',
  MODULES: 'modules',
  VALID_APPS: 'validApps',
  REGIONS: 'regions',
  ROUTES: 'routes',
  PERSONALIZATION: 'personalization',
  FEATURE_BY_ROUT_COUNT: 'featuresByRoutCount',
  IS_OPEN: 'isOpen',
  PAGE: 'page',
  IS_REPORTING_OPEN: 'isReportingOpen',
  OUTER_ROUTE: 'outerRoute',
  CURRENT_AGENT_STATUS: 'currentAgentStatus',
  BRAND_PROFILE: 'brandProfile',
  CUSTOM_AWAY_REASONS: 'customAwayReasons',
  LE_SOUND_ENABLE: 'leSoundEnable',
  LE_TRAIL_INFORMATION: 'trailInformation',
  TOP_BAR_NOTIFICATION: 'topBarNotification',
  PERSONA_NOTIFICATION: 'personaNotification',
};

export const other = 'other';




// WEBPACK FOOTER //
// ./src/store/modules/environment/keys.js